import 'regenerator-runtime/runtime';
import { call, put, takeEvery } from 'redux-saga/effects';
import { AnyAction } from 'redux';
import { DoRequestResponse, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export enum ANTRAGSNUMMER_GENERATION_EVENTS {
  ANTRAGSNUMMER_GENERATION_SUCCESSFUL = 'ANTRAGSNUMMER_GENERATION_SUCCESSFULL',
  ANTRAGSNUMMER_GENERATION_FAILED = 'ANTRAGSNUMMER_GENERATION_FAILED',
}

export function* watchAntragsnummerGenerate() {
  yield takeEvery(
    CheckoutActions.SAMMELANTRAGSNUMMER_REQUESTED,
    safeSaga(antragsnummerSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    GlobalActions.ANTRAGSNUMMER_GENERATED,
    safeSaga(antragsnummerSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    ANTRAGSNUMMER_GENERATION_EVENTS.ANTRAGSNUMMER_GENERATION_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* antragsnummerSaga(action?: AnyAction) {
  // an offer of a Tiergruppe that is not the last one: the group gets its number once
  if (action?.payload?.skipSammelantragsnummer) {
    return;
  }
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequestAntragsnummer(
      App.SHOP_CHECKOUT,
      ANTRAGSNUMMER_GENERATION_EVENTS.ANTRAGSNUMMER_GENERATION_SUCCESSFUL,
      ANTRAGSNUMMER_GENERATION_EVENTS.ANTRAGSNUMMER_GENERATION_FAILED,
    ),
  );
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  yield put({
    type: CheckoutActions.SAMMELANTRAGSNUMMER_GENERATED,
    payload: successAction.payload,
  });
}
